<template>
  <section class="panel">
    <div class="fading">
      <h1>Create a new memorial - Step 3 of 3</h1>
      <div class="text" v-html="text.new_step_3" v-if="text"></div>
      <div class="extras">
        <div :key="extra.ItemID" class="extra" v-for="(extra, i) in extras">
          <div class="extra-name">{{ extra.name }}</div>
          <slide-show :cycle="false" @slide-change="extra.slidenumber = $event" ref="slideshow">
            <div :key="option._id" v-for="(option, oi) in extra.products">
              <img :src="option.image" />
              <div class="checkbox">
                <input
                  :id="'chk' + extra.ItemID + '.' + option._id"
                  :value="[extra, option, i, oi]"
                  name
                  type="checkbox"
                  v-model="selected"
                />
                <label :for="'chk' + extra.ItemID + '.' + option._id">
                  <span>{{ option.name }}</span>
                </label>
              </div>
              <p class="option-desc">{{ option.description || extra.description }}</p>
            </div>
          </slide-show>
          <div class="controls" v-if="extra.products && extra.products.length > 1">
            <a
              @click.prevent="
                $refs.slideshow[i].show(extra.slidenumber > 1 ? extra.slidenumber - 1 : extra.products.length)
              "
              aria-label="Previous"
              class="prev"
              href
            >
              <font-awesome-icon icon="chevron-left" />
            </a>
            <a
              @click.prevent="
                $refs.slideshow[i].show(extra.slidenumber < extra.products.length ? extra.slidenumber + 1 : 1)
              "
              aria-label="Next"
              class="next"
              href
            >
              <font-awesome-icon icon="chevron-right" />
            </a>
          </div>
        </div>
      </div>

      <div class="actions">
        <button @click="$router.push('designer')" class="button back">Back</button>
        <button @click="finish" class="button">
          Continue
          <pulse></pulse>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import Pulse from "@/components/Pulse.vue"
export default {
  data() {
    return {
      selected: []
    }
  },
  components: {
    Pulse
  },
  computed: {
    text() {
      return this.$store.state.text
    },
    extras() {
      return this.$store.state.extras
    }
  },
  created() {
    this.selected = this.$store.state.selectedExtras
  },
  methods: {
    finish() {
      this.$store.commit("setSelectedExtras", this.selected)

      this.$router.push("summary")
    }
  }
}
</script>

<style scoped>
.text {
  max-width: 125rem;
  margin: auto;
}

.panel {
  text-align: center;
}
.background {
  width: 100%;
}
.extras {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 3rem;
  padding: 3rem 0;
  max-width: 125rem;
  margin: auto;
}

.extra {
  transition: all 0.3s;
  padding: 3rem;
  border-radius: 0.5rem;
  transition: all 0.3s;
  background: white;
  box-shadow: 0px 0px 22px 0px rgba(0, 0, 0, 0.05);
  text-align: left;
  position: relative;
  padding-bottom: 7rem;
}

.extra-name {
  font-size: 2rem;
  font-family: "Roboto Slab", serif;
  color: #b1ba22;
}
.extra-desc {
  font-size: 1.5rem;
}
.option-title {
  cursor: pointer;
}
.option-desc {
  font-size: 1.2rem;
  opacity: 0.6;
}
.extra.sel,
.extra.sel:hover {
  box-shadow: 0px 0px 22px 0px rgba(0, 0, 0, 0.21);
}
.extra:hover {
  box-shadow: 0px 0px 22px 0px rgba(0, 0, 0, 0.1);
}
.extra-tick {
  opacity: 0;
  transition: all 0.3s;
}
.extra:hover .extra-tick {
  opacity: 0.25;
}
.extra.sel .extra-tick {
  opacity: 1;
}

.extra-img {
  margin-top: 1.5rem;
  border-radius: 1rem;
}

.controls {
  padding-top: 3rem;
  text-align: left;
  position: absolute;
  bottom: 2rem;
}

@media screen and (max-width: 1050px) {
  .extras {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media screen and (max-width: 550px) {
  .extras {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
